import React from 'react';
import { CtaButton } from './ui/CtaButton';
import { SectionHeading } from './ui/SectionHeading';
import { products } from '../data/products';
import { WHATSAPP_ORDER_LINK } from '../utils/whatsapp';
export function Products() {
  return <section id="sabores" className="w-full scroll-mt-24 bg-cream px-4 pb-16 pt-4 sm:px-6 sm:pb-20" data-id="element-100" data-mp="3r6rsgaudvayc">
      <div className="mx-auto w-full max-w-6xl" data-id="element-101" data-mp="3n4n0dgjl2mdt">
        <SectionHeading title="Sabores disponibles" subtitle="Clásicos argentinos y opciones premium para todos los gustos." data-id="element-102" data-mp="3i7wiqos4riqa" />

        <ul className="mt-10 grid grid-cols-2 gap-4 lg:grid-cols-4" data-id="element-103" data-mp="3dawdgg33uk08">
          {products.map(product => <li key={product.id} className="flex h-full flex-col overflow-hidden rounded-2xl border border-aqua-200 bg-white shadow-soft transition-colors duration-200 hover:border-aqua-400" data-id="element-104" data-mp="347vbmrl9vf2d">
              <div className="relative" data-id="element-105" data-mp="12hjt335rtg3c">
                <img src={product.image} alt={product.name} className="aspect-square w-full object-cover" loading="lazy" data-id="element-106" data-mp="12ee2tkleo861" />
                {product.premium && <span className="absolute left-2 top-2 rounded-full border border-gold-400/70 bg-night-900/85 px-2 py-0.5 font-display text-[10px] uppercase tracking-[0.18em] text-gold-400" data-id="element-107" data-mp="zwd5z42aowmy">
                    Premium
                  </span>}
              </div>

              <div className="flex flex-1 flex-col p-3.5 sm:p-4" data-id="element-108" data-mp="1wmdowmfzgiwc">
                <p className="font-display text-[10px] uppercase tracking-[0.22em] text-aqua-600" data-id="element-109" data-mp="1wnymym1iajyy">
                  {product.category}
                </p>
                <h3 className="mt-1.5 font-display text-[16px] uppercase leading-tight tracking-wide text-night-900" data-id="element-110" data-mp="1muzli3kwuyxx">
                  {product.name}
                </h3>
                <p className="mt-1.5 text-[12.5px] leading-snug text-muted" data-id="element-111" data-mp="2fc3m1g77xgrf">
                  {product.description}
                </p>

                <p className="mt-auto pt-4 font-display text-[22px] font-semibold leading-none text-night-900" data-id="element-112" data-mp="2p70wjbxypw9s">
                  {product.price}
                </p>
                <CtaButton href={WHATSAPP_ORDER_LINK} size="sm" track="whatsapp-product-click" className="mt-3 w-full" aria-label={`Pedir ${product.name} por WhatsApp`} data-id="element-113" data-mp="2g74fnwhte1pa">
                  Pedir por WhatsApp
                </CtaButton>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}